import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import ImageGalleryPopup from "../../Components/UI-Controls/PopUp/ImageGalleryPapup/ImageGalleryPopup";
import { security_key, Url, configEditor_upd } from "../../Services/Api";
import axios from "axios";
import { uploadImage } from "../../Services/functions";
import JoditEditor from "jodit-react";
import BottomToust from "../../Components/BottomToust/BottomToust";
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import Flyer2 from "./flyer2";



const Flyers = () => {

    const [tabs, setTabs] = useState([
        {
            id: 1,
            name: "Flyer Images"
        },
        {
            id: 2,
            name: "Flyer Content"
        },
    ]);

    const [selectedTab, setSelectedTab] = useState(1);
    const [flyerData, setFlyerData] = useState(null);
    const [error, setError] = useState(null);
    const [modalView, setModalView] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [isUploaded, setIsUploaded] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedXImage, setSelectedXImage] = useState(null);
    const [uploadedStatus, setUploadedStates] = useState(null);
    const [imageType, setImageType] = useState("");
    const [imageGalleryPopup, setImageGalleryPopup] = useState(false);
    const [imageSendPayload, setImageSendPayload] = useState({
        file: null,
        alt_text: "",
        title: "",
        description: "",
        link_url: "",
    });

    const handleGalleryModalClose = () => {
        setModalView(false);
    };


    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        const api = `${Url}/api/v1/media/flyers/add`;

        if (file) {
            setImageSendPayload((prevData) => ({
                ...prevData,
                file: file,
            }));
            setUploadedStates("loading");
            alert("wait");
            const imagePayloadToSend = new FormData();
            imagePayloadToSend.append("image", file);
            imagePayloadToSend.append("alt_text", imageSendPayload.alt_text);
            imagePayloadToSend.append("title", imageSendPayload.title);
            imagePayloadToSend.append("description", imageSendPayload.description);
            imagePayloadToSend.append("image_url", imageSendPayload.image_url);
            imagePayloadToSend.append("link_url", imageSendPayload.link_url);
            await uploadImage(imagePayloadToSend, api, setUploadedStates);
        }
        setIsUploaded(true);
    };

    const getApi = async () => {
        try {
            const response = await axios.get(`${Url}/api/v1/media/flyers/get`);
            setModalData(response.data.media);
        } catch (error) {
            console.log(error);
        }
    };

    const handleImageSelect = (image) => {
        setFlyerData(prevData => ({
            ...prevData,
            flyers: {
                ...prevData.flyers,
                desktop: [...prevData.flyers.desktop, image]
            }
        }));
        setModalView(false);
    };


    const editor = useRef(null);

    const [selectedTabEditor, setSelectedTabEditor] = useState("Visual");
    const [startContent, setStartContent] = useState("");

    const [selectedTabEditor1, setSelectedTabEditor1] = useState("Visual");
    const [endContent, setEndContent] = useState("");


    const handleStartContentDataChange = (newContent) => {
        setStartContent(newContent)
    };

    const handleEndContentDataChange = (newContent) => {
        setEndContent(newContent)
    };

    const [loading, setLoading] = useState(false);
    const [openToust, setOpenToust] = useState(false);
    const [message, setMessage] = useState("");

    const handleOpenToust = (message) => {
        setOpenToust(true);
        setMessage(message);

        const timeout = setTimeout(() => {
            setOpenToust(false);
        }, 1500);
        return () => clearTimeout(timeout);
    }

    const handleCloseToust = () => {
        setOpenToust(false);
    }

    const fetchFlyer = async () => {
        try {
            const res = await fetch(`${Url}/api/v1/flyer`);
            const data = await res.json();

            if (!data.success) throw new Error(data.message);

            setFlyerData(data.data);
            setStartContent(data.data?.start_content)
            setEndContent(data.data?.end_content)
        } catch (err) {
            setError(err.message);
        }
    };



    useEffect(() => {
        fetchFlyer();
    }, []);



    const [searchTerm, setSearchTerm] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [showResults, setShowResults] = useState(false);


    useEffect(() => {

        if (!searchTerm.trim()) {
            setSearchResults([]);
            return;
        }

        const delayDebounce = setTimeout(async () => {
            try {
                setSearchLoading(true);

                const res = await fetch(
                    `https://fdapi.thefurnituredepots.com/api/v1/products/by-name?name=${searchTerm}&page=1&limit=100`
                );

                const data = await res.json();

                setSearchResults(data?.products || []);
                setShowResults(true);

            } catch (error) {
                console.error("Search error:", error);
            } finally {
                setSearchLoading(false);
            }
        }, 500); // 500ms debounce

        return () => clearTimeout(delayDebounce);

    }, [searchTerm]);

    const [updatedFlyerData, setUpdatedFlyerData] = useState(null)

    const handleFlyerPayload = (payload) => {
        console.log("🚀 PAYLOAD FROM CHILD:", payload);
        setUpdatedFlyerData(payload);
    };

    const createFlyerPayload = async (
    ) => {

        if (!updatedFlyerData) return null;

        const content1 =
            selectedTabEditor === "Visual"
                ? startContent
                : document.getElementById("startContent").value;
        const content2 =
            selectedTabEditor1 === "Visual"
                ? endContent
                : document.getElementById("endContent").value;

        // Immediately update the flyerData state with the new values
        setUpdatedFlyerData((prevData) => ({
            ...prevData,
            startContent: content1,
            endContent: content2,
        }));

        const transformedPages = updatedFlyerData.pages?.map(page => ({
            products: page.products
                ? page.products.map(product =>
                    product?._id ? product._id : product
                )
                : []
        })) || [];
        console.log({
            banner_url: updatedFlyerData.banner_url || "",
            banner_url_2: updatedFlyerData.banner_url_2 || "",

            start_content: updatedFlyerData.start_content || "",

            end_content: updatedFlyerData.end_content || "",

            pages: transformedPages
        })
        try {
            setLoading(true);
            const token = sessionStorage.getItem('authToken');
            const headers = {
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };
            // Use the updated content directly for the POST request
            const response = await axios.post(`${Url}/api/v1/flyer/add-or-update`, {
                banner_url: updatedFlyerData.banner_url || "",
            banner_url_2: updatedFlyerData.banner_url_2 || "",

                start_content: updatedFlyerData.start_content || "",

                end_content: updatedFlyerData.end_content || "",

                pages: transformedPages
            }, { headers: headers });

            if (response.status === 200) {
                handleOpenToust("Flyers Updated Successfully!");
                // setPPolicyData(response.data.content);
            } else {
                console.error("Failed to Update flyers:", response.statusText);
                handleOpenToust("Failed to Update flyers!");
            }
        } catch (error) {
            console.error("Error occurred:", error);
            setLoading(false);
            handleOpenToust("An error occurred while updating flyers!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flyers">
            <h2>Flyer</h2>
            <button onClick={() => { createFlyerPayload() }} className="add_update_btn">Update</button>
            <div className="flyer_selections_section">
                <div className="flyer_selections_section_left">
                    {
                        tabs.map((item) => {
                            return (
                                <div onClick={() => {
                                    setSelectedTab(item.id)
                                }} className={`flyer_selection_section ${item.id === selectedTab ? "selected" : ""}`}>
                                    {item.name}
                                </div>
                            )
                        })
                    }

                    <div
                        className="flyer_2_product_searchbar-search-cont"
                        style={{ position: "relative" }}
                    >
                        <p>Search Product</p>

                        <input
                            type="text"
                            placeholder="Search Furniture Depots"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onFocus={() => setShowResults(true)}
                        />

                        {/* RESULTS DROPDOWN */}
                        {showResults && (
                            <div className="search_results_dropdown">

                                {searchLoading && <p>Loading...</p>}

                                {!searchLoading && searchResults.length === 0 && (
                                    <p>No products found</p>
                                )}

                                {searchResults.map(product => (
                                    <div
                                        key={product._id}
                                        className="search_result_item"
                                        draggable
                                        onDragStart={(e) => {
                                            const productString = JSON.stringify(product);

                                            e.dataTransfer.setData("product", productString);

                                            console.log("Stored Product:", productString);
                                        }}
                                    >
                                        <img
                                            src={Url + product.image?.image_url}
                                            alt={product.name}
                                        />
                                        <div>
                                            <p>{product.name}</p>
                                            <span>${product.sale_price}</span>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        )}
                    </div>


                </div>

                {selectedTab === 1 ? <div className="flyer_selections_section_right">
            
                    <div className="flyer_images_list">
                        <Flyer2 error={error} flyerData={flyerData} setFlyerData={setFlyerData} onPayloadChange={handleFlyerPayload} />
                    </div>

                </div> :
                    selectedTab === 2 ?
                        <div className="flyer_selections_section_right">

                            <div className="editorSection_flyer">
                                <p className="heading_1">Start Content</p>
                                <div className="General-Editor-Container">
                                    <div className="General-Editor-Tabs">
                                        <div
                                            className={`Tab ${selectedTabEditor === "Visual" ? "active" : ""}`}
                                            onClick={() => setSelectedTabEditor("Visual")}
                                        >
                                            Visual
                                        </div>
                                        <div
                                            className={`Tab ${selectedTabEditor === "Text" ? "active" : ""}`}
                                            onClick={() => setSelectedTabEditor("Text")}
                                        >
                                            Text
                                        </div>
                                    </div>
                                    <div className="General-Editor-Content">
                                        {selectedTabEditor === "Visual" ? (
                                            <JoditEditor
                                                ref={editor}
                                                value={startContent}
                                                tabIndex={1}
                                                onBlur={handleStartContentDataChange}
                                                config={configEditor_upd}
                                            />
                                        ) : (
                                            <textarea
                                                id="startContent"
                                                name="startContent"
                                                value={startContent}
                                                onChange={(e) => setStartContent(e.target.value)}
                                                className="General-Editor-Text-Area"
                                                placeholder="Start Content"
                                            />
                                        )}
                                    </div>
                                </div>

                            </div>

                            <div className="editorSection_flyer">
                                <p className="heading_1">Last Content</p>
                                <div className="General-Editor-Container">
                                    <div className="General-Editor-Tabs">
                                        <div
                                            className={`Tab ${selectedTabEditor1 === "Visual" ? "active" : ""}`}
                                            onClick={() => setSelectedTabEditor1("Visual")}
                                        >
                                            Visual
                                        </div>
                                        <div
                                            className={`Tab ${selectedTabEditor1 === "Text" ? "active" : ""}`}
                                            onClick={() => setSelectedTabEditor1("Text")}
                                        >
                                            Text
                                        </div>
                                    </div>
                                    <div className="General-Editor-Content">
                                        {selectedTabEditor1 === "Visual" ? (
                                            <JoditEditor
                                                ref={editor}
                                                value={endContent}
                                                tabIndex={1}
                                                onBlur={handleEndContentDataChange}
                                                config={configEditor_upd}
                                            />
                                        ) : (

                                            <textarea
                                                id="endContent"
                                                name="endContent"
                                                value={endContent}
                                                onChange={(e) => setEndContent(e.target.value)}
                                                className="General-Editor-Text-Area"
                                                placeholder="End Content"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>


                        </div> : <></>}
            </div>
            <ImageGalleryPopup
                showImageGalleryPopUp={modalView}
                handleModalView={handleGalleryModalClose}
                handleFileChange={handleFileChange}
                imageSendPayload={imageSendPayload}
                setImageSendPayload={setImageSendPayload}
                alt_text={imageSendPayload.alt_text}
                title={imageSendPayload.title}
                data={modalData}
                getData={getApi}
                onImageSelect={handleImageSelect}
            />

            <BottomToust
                message={message}
                showMessage={openToust}
                handleCloseToust={handleCloseToust}
            />
            {loading && <div className="backdrop">
                <div className="loader-container">
                    <MainLoader heading1={"Updating Flyer Content"} />
                </div>
            </div>}
        </div>
    );
};

export default Flyers;
